import React from 'react';
import PropTypes from 'prop-types';

/* Molecules */
import InboxConversation from '../InboxConversation/InboxConversation';

import './InboxConversations.less';

const InboxConversations = ({
    conversations = [],
    translations = {},
    isVrbexNative = false,
}) => {
    const conversationsElement = conversations.map((conversation) => {
        return (
            <InboxConversation
                key={conversation.conversationID}
                translations={translations}
                {...conversation}
                isVrbexNative={isVrbexNative}
            />
        );
    });

    return <div className="InboxConversations">{conversationsElement}</div>;
};

InboxConversations.propTypes = {
    conversations: PropTypes.arrayOf(PropTypes.object),
    isVrbexNative: PropTypes.bool,
    translations: PropTypes.shape({}),
};

export default InboxConversations;
